import { render, staticRenderFns } from "./AgentDetailPage.vue?vue&type=template&id=b9f65f26&scoped=true"
import script from "./AgentDetailPage.vue?vue&type=script&lang=js"
export * from "./AgentDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AgentDetailPage.vue?vue&type=style&index=0&id=b9f65f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f65f26",
  null
  
)

export default component.exports